import { render } from "./_new.vue?vue&type=template&id=d98e2ae6"
import script from "./_new.vue?vue&type=script&lang=js"
export * from "./_new.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__